// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderRelevance\ApiPilotJobOrderRelevance.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// PilotJobOrderRelevanceData is the class that PilotJobOrderRelevance serializes to/from
export interface PilotJobOrderRelevanceData {
    EventId : number;
    PilotJobOrderId : number;
	
    Event : EventData | null;
    PilotJobOrder : PilotJobOrderData | null;
	
}

// PilotJobOrderRelevanceOptions is the class which may be passed to the PilotJobOrderRelevance constructor to define optional initial data values
export interface PilotJobOrderRelevanceOptions {
    EventId : number;
    PilotJobOrderId : number;
	
    Event? : EventOptions | null;
    PilotJobOrder? : PilotJobOrderOptions | null;
	
}

export class PilotJobOrderRelevance {
    public EventId : DataSignal<number>;
    public PilotJobOrderId : DataSignal<number>;
	
    public Event : DataSignal<Event | null>;
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
	

    constructor();
    constructor(data : PilotJobOrderRelevanceOptions);
    constructor(data: PilotJobOrderRelevanceOptions | null = null) {
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.PilotJobOrderId = jsonableObservable(S.value<number>(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
	    
        this.Event = S.value<Event | null>(null);
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
	    
    }

    static key(obj : PilotJobOrderRelevance) {
        return obj.EventId() + '\u2618' + obj.PilotJobOrderId();
    }
    
    static dataKey(obj : PilotJobOrderRelevanceOptions) {
        return obj.EventId + '\u2618' + obj.PilotJobOrderId;
    }

    static update(obj : PilotJobOrderRelevance, data : PilotJobOrderRelevanceOptions) {
        S.freeze(() => {
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.PilotJobOrderId !== undefined) obj.PilotJobOrderId(data.PilotJobOrderId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrderRelevance.ts